'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { IllustrationOnTheLeftLayout } from '@algoacademy/design-system/web/layouts/IllustrationOnTheLeftLayout';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H2 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import { useState } from 'react';
import { EbookPopup } from '../_components/EbookPopup';
import ManReadingAnArticle from '../_svg/ManReadingAnArticle';
export function EbookSection() {
  const $ = _c(10);
  const [isEbookOpen, setEbookOpen] = useState(false);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ManReadingAnArticle />;
    t1 = <H2>Darmowy e-book „Nasza metoda nauczania”</H2>;
    t2 = <VerticalSpacer size="content" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <P2>Chcesz poznać naszą metodę szczegółowo?{t3}Pobierz bezpłatny <span className="whitespace-nowrap">e-book</span> i{"\xA0"}dowiedz się więcej.</P2>;
    t5 = <VerticalSpacer size="content" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IllustrationOnTheLeftLayout illustration={t0}>{t1}{t2}{t4}{t5}<Button size="xl" onClick={() => setEbookOpen(true)} className="w-full lg:w-fit">Pobierz e-book</Button></IllustrationOnTheLeftLayout>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setEbookOpen(false);
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isEbookOpen) {
    t8 = <>{t6}<EbookPopup open={isEbookOpen} onClose={t7} /></>;
    $[8] = isEbookOpen;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
}